import isEmpty from 'lodash/isEmpty';
import { observer } from 'mobx-react-lite';
import EmptyNotifications from 'molecules/Notifications/EmptyNotifications';
import NotificationFooter from 'molecules/Notifications/NotificationFooter';
import NotificationList from 'molecules/Notifications/NotificationList';
import React, { useEffect } from 'react';
import { useStore } from 'stores/store';
import { useWatchNotificationApi } from 'utils/hooks/useWatchNotificationApi';

import s from '../Notifications.module.scss';

const WatchNotifications = ({ unread }: { unread?: boolean }) => {
  const { NotificationStore } = useStore();
  const { onLoadMore, onNavigate, setUnread, onToggleUnread, setReadAll, isLoading } =
    useWatchNotificationApi({
      unread
    });

  useEffect(() => {
    setUnread(unread);
  }, [unread, setUnread]);

  const showLoading = isLoading && isEmpty(NotificationStore.watchMessages);
  const hasMore =
    !isEmpty(NotificationStore.watchMessages) &&
    NotificationStore.watchMessages.length <
      (unread ? NotificationStore.unreadWatchCount : NotificationStore.totalWatchCount);

  return (
    <div className={s.Notifications}>
      {!isEmpty(NotificationStore.watchMessages) ? (
        <NotificationList
          onNavigate={onNavigate}
          onToggleUnread={onToggleUnread}
          items={NotificationStore.watchMessages}
        />
      ) : (
        <EmptyNotifications isLoading={showLoading} />
      )}
      <NotificationFooter onLoadMore={onLoadMore} setReadAll={setReadAll} />
    </div>
  );
};

export default observer(WatchNotifications);
